import * as m from '@/paraglide/messages';
import { cn } from '@listening/utils/react-helpers';
import '@/styles/astro/new-design.css';
import PlaceholderAvatar from '@listening/assets/astro/images/Frame-1362789785.png';
import SeanGruber from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-1.png';
import ErinBarnes from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-2.png';
import RóisínHennessy from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-3.png';
import MandyEversole from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-4.png';
import BreaT from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-5.png';
import MaryBallardJohansson from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-6.png';
import DavidHoeffer from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-7.png';
import ReadE from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-8.png';
import SamanthaLumby from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-9.png';
import BaobeiDeBei from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-10.png';
import JosephWaters from '@listening/assets/astro/images/Frame-1362789785-2_1.png';
import AubreyWilliams from '@listening/assets/astro/images/Frame-1362789785-3_1.png';
import MicahRobbins from '@listening/assets/astro/images/Frame-1362789785-4_1.png';
import JudyAdams from '@listening/assets/astro/images/Frame-1362789785-5.png';
import testimonialsAvatars from '@listening/assets/astro/images/testimonials-avatars.png';

import { Button } from '@listening/frontend/components/radix/button';
import { Link } from '@tanstack/react-router';
import { useCtaHref } from '@/components/astro/cta-button/cta-button.tsx';
import './Testimonials.css';

const MelomanF = PlaceholderAvatar;
const TimOsterbuhr = PlaceholderAvatar;

const columnsData: {
  comment: () => string;
  avatar: string;
  alt: string;
  name: string;
}[][] = [
  [
    {
      comment: () => m.testimonial_tim_osterbuhr(),
      avatar: TimOsterbuhr,
      alt: 'Profile photo of Tim Osterbuhr',
      name: 'Tim Osterbuhr',
    },
    {
      comment: () => m.testimonial_sean_gruber(),
      avatar: SeanGruber,
      alt: 'Profile photo of Sean Gruber',
      name: 'Sean Gruber',
    },
    {
      comment: () => m.testimonial_erin_barnes(),
      avatar: ErinBarnes,
      alt: 'Profile photo of Erin Barnes',
      name: 'Erin Barnes',
    },
    {
      comment: () => m.testimonial_joseph_waters(),
      avatar: JosephWaters,
      alt: 'Profile photo of Joseph Waters',
      name: 'Joseph Waters',
    },
    {
      comment: () => m.testimonial_sean_gruber(),
      avatar: MandyEversole,
      alt: 'Profile photo of Sean Gruber',
      name: 'Sean Gruber',
    },
    {
      comment: () => m.testimonial_erin_barnes(),
      avatar: BreaT,
      alt: 'Profile photo of Erin Barnes',
      name: 'Erin Barnes',
    },
  ],
  [
    {
      comment: () => m.testimonial_roisin_hennessy(),
      avatar: RóisínHennessy,
      alt: 'Profile photo of Róisín Hennessy',
      name: 'Róisín Hennessy',
    },
    {
      comment: () => m.testimonial_mandy_eversole(),
      avatar: MandyEversole,
      alt: 'Profile photo of Mandy Eversole',
      name: 'Mandy Eversole',
    },
    {
      comment: () => m.testimonial_brea_t(),
      avatar: BreaT,
      alt: 'Profile photo of Brea T.',
      name: 'Brea T.',
    },
    {
      comment: () => m.testimonial_micah_robbins(),
      avatar: MicahRobbins,
      alt: 'Profile photo of Micah Robbins',
      name: 'Micah Robbins',
    },
  ],
  [
    {
      comment: () => m.testimonial_mary_ballard_johansson(),
      avatar: MaryBallardJohansson,
      alt: 'Profile photo of Mary Ballard-Johansson',
      name: 'Mary Ballard-Johansson',
    },
    {
      comment: () => m.testimonial_david_hoeffer(),
      avatar: DavidHoeffer,
      alt: 'Profile photo of David Hoeffer',
      name: 'David Hoeffer',
    },
    {
      comment: () => m.testimonial_meloman_f(),
      avatar: MelomanF,
      alt: 'Profile photo of Meloman F.',
      name: 'Meloman F.',
    },
    {
      comment: () => m.testimonial_aubrey_williams(),
      avatar: AubreyWilliams,
      alt: 'Profile photo of Aubrey Williams',
      name: 'Aubrey Williams',
    },
    {
      comment: () => m.testimonial_mary_ballard_johansson(),
      avatar: MaryBallardJohansson,
      alt: 'Profile photo of Mary Ballard-Johansson',
      name: 'Mary Ballard-Johansson',
    },
    {
      comment: () => m.testimonial_david_hoeffer(),
      avatar: DavidHoeffer,
      alt: 'Profile photo of David Hoeffer',
      name: 'David Hoeffer',
    },
  ],
  [
    {
      comment: () => m.testimonial_read_e(),
      avatar: ReadE,
      alt: 'Profile photo of Read E',
      name: 'Read E',
    },
    {
      comment: () => m.testimonial_samantha_lumby(),
      avatar: SamanthaLumby,
      alt: 'Profile photo of Samantha Lumby',
      name: 'Samantha Lumby',
    },
    {
      comment: () => m.testimonial_baobei_de_bei(),
      avatar: BaobeiDeBei,
      alt: 'Profile photo of Baobei de Bei',
      name: 'Baobei de Bei',
    },
    {
      comment: () => m.testimonial_judy_adams(),
      avatar: JudyAdams,
      alt: 'Profile photo of Judy Adams',
      name: 'Judy Adams',
    },
  ],
];

const columnClasses = [
  { animation: 'scroll-down', height: 'h-[1200px]', responsive: '' },
  {
    animation: 'scroll-up',
    height: 'h-[1200px]',
    responsive: 'hidden lg:block',
  },
  {
    animation: 'scroll-down',
    height: 'h-[1200px]',
    responsive: 'hidden md:block',
  },
  {
    animation: 'scroll-up',
    height: 'h-[1200px]',
    responsive: 'hidden lg:block',
  },
];

export function Testimonials() {
  const ctaHref = useCtaHref();
  return (
    <section
      aria-labelledby='testimonials-heading'
      className='flex flex-col items-stretch px-0 pt-9'
    >
      <div
        aria-hidden='true'
        className='relative flex flex-row items-center pb-4'
      >
        <div className='absolute inset-x-0 top-1/2 bottom-0 -z-10' />
      </div>
      <div
        aria-label='Customer testimonials'
        className='relative flex flex-col items-center gap-8 px-0 pb-8 sm:px-8'
        id='customers'
        role='region'
      >
        <div
          className='flex flex-col items-center gap-8 px-2 pt-3'
          role='banner'
        >
          <h2
            className='text-center text-2xl font-bold sm:text-6xl'
            id='testimonials-heading'
          >
            {m.testimonials_heading()}
          </h2>
          <div
            className='flex flex-col items-center gap-3'
            role='complementary'
          >
            <div className='flex items-center justify-center'>
              <img
                alt='Avatars of our users'
                className='h-auto w-full'
                loading='lazy'
                src={testimonialsAvatars}
              />
            </div>
            <div className='text-center text-neutral-665 sm:text-xl lg:leading-[24px]'>
              {m.testimonials_subtitle_prefix()}{' '}
              <span className='font-bold'>
                {m.testimonials_subtitle_bold()}
              </span>{' '}
              {m.testimonials_subtitle_suffix()}
            </div>
          </div>
        </div>
        <div className='relative w-full max-w-[1600px]'>
          <div>
            <div
              aria-hidden='true'
              className='pointer-events-none absolute inset-x-0 top-0 z-10 h-[140px] bg-linear-to-b from-white via-white/90 to-transparent'
            />

            <div
              aria-label='Customer testimonials grid'
              className='relative flex max-h-[1200px] flex-nowrap items-start justify-center gap-x-4 overflow-hidden p-2'
              role='list'
            >
              {columnsData.map((testimonials, index) => {
                const columnClass = columnClasses[index];
                if (!columnClass) return null;
                const { animation, height, responsive } = columnClass;
                return (
                  <div
                    className={cn(
                      'testimonial-column relative flex-1 overflow-hidden',
                      height,
                      responsive,
                    )}
                    key={`testimonials-column-${index.toString()}`}
                    role='list'
                  >
                    <div className={cn(animation, 'flex flex-col gap-4')}>
                      {testimonials.map((testimonial, idx) => (
                        <div
                          className='testimonial-card group relative mx-2 flex flex-col gap-4 overflow-hidden rounded-2xl bg-white p-6 transition-all duration-300 sm:mx-0'
                          key={`${testimonial.name}-${idx.toString()}`}
                          role='listitem'
                        >
                          <div aria-hidden='true' className='gradient-bg' />

                          <blockquote className='relative z-10 font-["Poppins"] text-sm leading-[1.8] text-neutral-665'>
                            {testimonial.comment()}
                          </blockquote>
                          <div className='z-10 mt-auto flex items-center gap-4'>
                            <div className='overflow-hidden rounded-full transition-transform duration-300 group-hover:scale-105'>
                              <img
                                alt={testimonial.alt}
                                className='size-12 rounded-full'
                                height={48}
                                loading='lazy'
                                src={testimonial.avatar}
                                width={48}
                              />
                            </div>
                            <div className='flex flex-col justify-center'>
                              <cite className='text-[14px] leading-[21.6px] font-semibold text-navy-920 transition-colors duration-300'>
                                {testimonial.name}
                              </cite>
                            </div>
                          </div>
                        </div>
                      ))}
                      {testimonials.map((testimonial, idx) => (
                        <div
                          className='testimonial-card group relative mx-2 flex flex-col gap-4 overflow-hidden rounded-2xl bg-white p-6 transition-all duration-300 sm:mx-0'
                          key={`${testimonial.name}-${idx.toString()}`}
                          role='listitem'
                        >
                          <div aria-hidden='true' className='gradient-bg' />

                          <blockquote className='relative z-10 font-["Poppins"] text-sm leading-[1.8] text-neutral-665'>
                            {testimonial.comment()}
                          </blockquote>
                          <div className='z-10 mt-auto flex items-center gap-4'>
                            <div className='overflow-hidden rounded-full transition-transform duration-300 group-hover:scale-105'>
                              <img
                                alt={testimonial.alt}
                                className='size-12 rounded-full'
                                height={48}
                                loading='lazy'
                                src={testimonial.avatar}
                                width={48}
                              />
                            </div>
                            <div className='flex flex-col justify-center'>
                              <cite className='text-[14px] leading-[21.6px] font-semibold text-navy-920 transition-colors duration-300'>
                                {testimonial.name}
                              </cite>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            <div
              aria-hidden='true'
              className='pointer-events-none absolute inset-x-0 bottom-0 z-10 h-[100px] bg-linear-to-t from-white via-white/90 to-transparent'
            />
          </div>
        </div>
        <div className='relative z-10' role='complementary'>
          <Button
            animated
            asChild
            className='rounded-full bg-royal-50 px-6 py-4 text-base font-medium text-white transition-all duration-300 hover:bg-royal-50/80 hover:shadow-lg sm:px-24 sm:py-8 sm:text-lg'
          >
            <Link aria-label='Sign up for a free account' to={ctaHref}>
              {m.testimonials_signup_button()}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
